import { render, staticRenderFns } from "./TableRowMarketingSpendPer.vue?vue&type=template&id=845ea188&lang=pug&"
import script from "./TableRowMarketingSpendPer.vue?vue&type=script&lang=js&"
export * from "./TableRowMarketingSpendPer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('845ea188')) {
      api.createRecord('845ea188', component.options)
    } else {
      api.reload('845ea188', component.options)
    }
    module.hot.accept("./TableRowMarketingSpendPer.vue?vue&type=template&id=845ea188&lang=pug&", function () {
      api.rerender('845ea188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/performance-evaluation/table-rows/TableRowMarketingSpendPer.vue"
export default component.exports